import { useEffect, useState } from 'react'

/**
 * Determines whether the current platform is macOS.
 */
const useIsMacOS = (): boolean => {
  const [isMacOS, setIsMacOS] = useState<boolean>(false)

  useEffect(() => {
    const uaData = (
      navigator as Navigator & { userAgentData?: { platform?: string } }
    ).userAgentData
    if (uaData?.platform) {
      setIsMacOS(uaData.platform.toLowerCase().includes('mac'))
    } else {
      setIsMacOS(navigator.platform.toLowerCase().includes('mac'))
    }
  }, [])

  return isMacOS
}

export default useIsMacOS